import { api } from './api';

export interface PersonnelListItem {
  id: number;
  firstName: string;
  lastName: string;
}

/**
 * Tüm rollerde (Admin, Yönetici, Personel) erişilebilen personel listesi.
 * Sadece id, ad, soyad döner; servis fişi sorumlu/teslim eden/teknisyen seçimleri için kullanılır.
 */
export async function fetchPersonnelList(): Promise<PersonnelListItem[]> {
  const { data } = await api.get<PersonnelListItem[]>('/personnel');
  return Array.isArray(data) ? data : [];
}
